import Vue from 'vue';
import App from '@/core/components/app/app.vue';
import './registerServiceWorker';
import router from '@/core/components/router/';
import store from './store';
import { initPlugins } from '@/plugins/';
import { init } from '@/core/bootstrap/';

Vue.config.productionTip = false;

(async () => {
	initPlugins();
	init();

	new Vue({
		router,
		store,
		render: (h) => h(App)
	}).$mount('#app');
})();
